import { createStore as createReduxStore, Reducer } from 'redux'
import { ReduxState } from './types'

type CreateStore = {
  rootReducer: Reducer
  initialState: ReduxState
}

/**
 * Wrapper method around redux' createStore function (useful for mocking in tests).
 */
const createStore = ({ rootReducer, initialState }: CreateStore) =>
  createReduxStore(
    rootReducer,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )

export default createStore
